import { useMemo } from 'react';
import useAttestationResults from '@sdk/timeClock/hooks/useAttestationResults';
import { BreakAttestation } from '@sdk/automatedBreaks/types/Attestation';

import { useAutomatedBreaksSettings } from '@web/settings/components/schedule/Breaks/breaks.hooks';

export const useAttestationsToDisplay = (
  breakAttestations: BreakAttestation[],
  withCaption: boolean
) => {
  const { automatedBreaks } = useAutomatedBreaksSettings();
  const getAttestationsToDisplay = useAttestationResults({
    automatedBreaksSettings: automatedBreaks,
    withCaption,
  });
  const attestationsToDisplay = useMemo(
    () => getAttestationsToDisplay(breakAttestations),
    [breakAttestations, getAttestationsToDisplay]
  );

  return attestationsToDisplay;
};
